export const truncateString = (str, num) => {
	if (str.length <= num) {
		return str
	}
	return str.slice(0, num)
}

export const setCookie = (cookieKey, cookieValue, expirationDays) => {
	let expiryDate = '';

	if (expirationDays) {
		const date = new Date();

		date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);

		expiryDate = `; expires=" ${date.toUTCString()}`;
	}

	document.cookie = `${cookieKey}=${cookieValue || ''}${expiryDate}; path=/`;
}

export const getCookie = (cookieKey) => {
	let cookieName = `${cookieKey}=`;

	let cookieArray = document.cookie.split(';');

	for (let cookie of cookieArray) {

		while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1, cookie.length);
		}

		if (cookie.indexOf(cookieName) === 0) {
			return cookie.substring(cookieName.length, cookie.length);
		}
	}
}

export const isSEO = (adobeMcRef) => {
	const searchEngineDomains = ['google.com', 'bing.com', 'yahoo.com', 'aol.com', 'yandex.com', 'yam.com', 'yahoo.', 'wp.pl',
		'wow.com', 'webcrawler.com', 'voila.fr', 'virgilio.it', 'vinden.nl', 'twcc.com', 'thenexttask.com', 'terra.com',
		'teoma.com', 'startpagina.nl', 'smart-search.eu', 'smarter.com', 'seznam.cz', 'searchnow.com', 'searchlock3.com',
		'searchlock.com', 'searchincognito.com', 'searchassist.verizon.com', 'searchalot.com', 'searchall.com',
		'search.xfinity.com', 'search.whiteskyservices.com', 'search.pch.com', 'search.mediacomcable.com', 'search.com',
		'reference.com', 'rambler.ru', 'netscape.com', 'naver.com', 'mywebsearch.com', 'myprivatesearch.com', 'msn.com',
		'lycos.com', 'kvasir.no', 'ixquick.com', 'isearch.avg.com', 'greenwichmeantime.com', 'googleweblight.com', 'google.',
		'go4g.airtel.in', 'frontpage.pch.com', 'frontier.com', 'eniro.se', 'ekolay.net', 'earthlink.net', 'duckduckgo.com',
		'dogpile.com', 'dnserrorassist.att.net', 'daum.net', 'contenko.com', 'cnn.com/SEARCH/', 'baidu.com', 'ask.com',
		'aol.com', 'altavista.com', 'alot.com', 'alltheweb.com', 'alice.com', 'about.com'
	];

	const testLink = document.createElement('a')
	testLink.href = adobeMcRef || document.referrer;
	const referrer = testLink.host.split('www.').pop()

	return searchEngineDomains.some(domain => domain === referrer);
}

export const _raf = () => {
	if (typeof window !== 'undefined') {
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			function (callback) {
				window.setTimeout(callback, 1000 / 60);
			};
	}
	return
}

export const isElInView = (ref) => {
	if (typeof window !== 'undefined') {

		const scroll = window.scrollY || window.pageYOffset;
		const boundsTop = ref.current.getBoundingClientRect().top + scroll;

		const viewport = {
			top: scroll,
			bottom: scroll + window.innerHeight
		};

		const bounds = {
			top: boundsTop,
			bottom: boundsTop + ref.current.clientHeight
		};

		return (
			(bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
			(bounds.top <= viewport.bottom && bounds.top >= viewport.top)
		);
	}
	return
};